import { Icon, IconProps } from './Icon';

interface EconomyIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const EconomyIcon = ({ color = '#C2E2FF', gradient, ...props }: EconomyIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 45 45"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <g clipPath="url(#clip0_5287_12442)">
      <path
        d="M20.0806 4.47825C21.1961 2.6842 23.8072 2.6842 24.9226 4.47826L29.7216 12.1967C30.114 12.8279 30.7375 13.2809 31.4591 13.4591L40.2827 15.638C42.3337 16.1445 43.1405 18.6278 41.779 20.243L35.9213 27.1922C35.4422 27.7605 35.2041 28.4935 35.2576 29.2348L35.9119 38.2999C36.064 40.407 33.9516 41.9417 31.9947 41.146L23.5755 37.7224C22.8869 37.4424 22.1163 37.4424 21.4278 37.7224L13.0086 41.146C11.0516 41.9417 8.9392 40.407 9.0913 38.2999L9.74564 29.2348C9.79916 28.4935 9.56101 27.7605 9.08196 27.1922L3.22427 20.243C1.86271 18.6278 2.66959 16.1445 4.72053 15.638L13.5441 13.4591C14.2657 13.2809 14.8892 12.8279 15.2817 12.1967L20.0806 4.47825Z"
        fill={gradient ? `url(#${gradient.id})` : color}
      />
    </g>
    <defs>
      <clipPath id="clip0_5287_12442">
        <rect
          width="45"
          height="45"
          fill="white"
        />
      </clipPath>
    </defs>
  </Icon>
);
